import styled, { css } from 'foundations-theming/utils';
// @ts-ignore untyped modules
import GlobalContentNoAccessLabel from './GlobalContentNoAccessLabel';
import ModuleNotDraggableLabel from './ModuleNotDraggableLabel';
import { getLayoutSectionHoverOverlayColors } from '../lib/layoutSection/constants';
// @ts-ignore untyped modules
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { useSelector } from 'react-redux';
import { getIsTrellisTheme } from '../redux/selectors/layoutSectionDndSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const withAlpha = (hex, opacity) => {
  const hexOpacity = Math.round(opacity * 255).toString(16).padStart(2, '0');
  return `${hex}${hexOpacity}`;
};
const repeatingLinearGratient = (angle, ...colorStops) => `
  repeating-linear-gradient(${angle}deg, ${colorStops.join(', ')});
`;
const unEditableDiagonalBars = colors => css(["background:", ";"], repeatingLinearGratient(45, withAlpha(colors.UNEDITABLE_DIAGONAL_BARS_ONE, 0.2), `${withAlpha(colors.UNEDITABLE_DIAGONAL_BARS_ONE, 0.2)} 30px`, `${withAlpha(colors.UNEDITABLE_DIAGONAL_BARS_TWO, 0.6)} 30px`, `${withAlpha(colors.UNEDITABLE_DIAGONAL_BARS_TWO, 0.6)} 60px`));
const removeModuleDiagonalBars = colors => css(["background:", ";"], repeatingLinearGratient(135, withAlpha(colors.REMOVE_MODULE_DIAGONAL_BARS_ONE, 0.2), `${withAlpha(colors.REMOVE_MODULE_DIAGONAL_BARS_ONE, 0.2)} 30px`, `${withAlpha(colors.REMOVE_MODULE_DIAGONAL_BARS_TWO, 0.6)} 30px`, `${withAlpha(colors.REMOVE_MODULE_DIAGONAL_BARS_TWO, 0.6)} 60px`));
const cleanLinesRemoveModuleDiagonalBars = colors => css(["background:", ";"], repeatingLinearGratient(135, withAlpha(colors.REMOVE_MODULE_DIAGONAL_BARS_ONE, 0.15), `${withAlpha(colors.REMOVE_MODULE_DIAGONAL_BARS_ONE, 0.15)} 30px`, `${withAlpha(colors.REMOVE_MODULE_DIAGONAL_BARS_TWO, 0.5)} 30px`, `${withAlpha(colors.REMOVE_MODULE_DIAGONAL_BARS_TWO, 0.5)} 60px`));
const updatedEditorStyles = colors => css(["outline:2px solid ", ";outline-offset:-2px;background:none;"], colors.UPDATED_OUTLINE);
const baseGlobalEmbedOrGroupStyles = css(["cursor:pointer;pointer-events:auto;z-index:5000;"]);
const globalGroupUpdatedEditorStyles = colors => css(["background-color:", ";outline:2px solid ", ";"], withAlpha(colors.GLOBAL_GROUP_BACKGROUND, 0.4), colors.GLOBAL_GROUP_OUTLINE);
const embedUpdatedEditorStyles = colors => css(["background-color:", ";outline:2px solid ", ";"], withAlpha(colors.EMBED_BACKGROUND, 0.2), colors.EMBED_OUTLINE);
const moduleBlockedStyles = colors => css(["", " cursor:not-allowed;"], unEditableDiagonalBars(colors));
const moduleWithoutAccessStyles = colors => css(["", " cursor:pointer;outline-color:", ";pointer-events:auto;"], removeModuleDiagonalBars(colors), colors.MODULE_WITHOUT_ACCESS_OUTLINE);
const richTextWihtoutAccessStyles = colors => css(["background:", " !important;cursor:pointer;outline-color:", " !important;pointer-events:auto;"], withAlpha(colors.RICH_TEXT_WITHOUT_ACCESS_BACKGROUND, 0.2), colors.RICH_TEXT_WITHOUT_ACCESS_OUTLINE);
const StyledLayoutSectionHoverOverlay = styled.div.withConfig({
  displayName: "LayoutSectionHoverOverlay__StyledLayoutSectionHoverOverlay"
})([".hs-private.hs-private.hs-private &&{position:absolute;background:", ";box-sizing:border-box;outline:3px solid ", ";outline-offset:-3px;", " ", " ", " ", " ", " ", " ", " ", " ", "}"], ({
  $colors
}) => withAlpha($colors.DEFAULT_BACKGROUND, 0.3), ({
  $colors
}) => $colors.DEFAULT_OUTLINE, ({
  $isNonLSModuleHoverOverlayGlobalGroup,
  $isNonLSModuleHoverOverlayEmbed
}) => ($isNonLSModuleHoverOverlayGlobalGroup || $isNonLSModuleHoverOverlayEmbed) && baseGlobalEmbedOrGroupStyles, ({
  $isUneditable,
  $colors
}) => $isUneditable && unEditableDiagonalBars($colors), ({
  $isNonLSModuleHoverOverlayBlocked,
  $colors
}) => $isNonLSModuleHoverOverlayBlocked && moduleBlockedStyles($colors), ({
  $hasUpdatedEditorStyles,
  $colors
}) => $hasUpdatedEditorStyles && updatedEditorStyles($colors), ({
  $isNonLSModuleHoverOverlayGlobalGroup,
  $hasUpdatedEditorStyles,
  $colors
}) => $isNonLSModuleHoverOverlayGlobalGroup && $hasUpdatedEditorStyles && globalGroupUpdatedEditorStyles($colors), ({
  $isNonLSModuleHoverOverlayEmbed,
  $hasUpdatedEditorStyles,
  $colors
}) => $isNonLSModuleHoverOverlayEmbed && $hasUpdatedEditorStyles && embedUpdatedEditorStyles($colors), ({
  $isNonLSModuleHoverOverlayWithoutAccess,
  $colors
}) => $isNonLSModuleHoverOverlayWithoutAccess && moduleWithoutAccessStyles($colors), ({
  $hasCleanLinesWithoutAccessBars,
  $colors
}) => $hasCleanLinesWithoutAccessBars && cleanLinesRemoveModuleDiagonalBars($colors), ({
  $isNonLSModuleHoverOverlayRichTextWithModulesWithoutAccess,
  $colors
}) => $isNonLSModuleHoverOverlayRichTextWithModulesWithoutAccess && richTextWihtoutAccessStyles($colors));
const LayoutSectionHoverOverlay = ({
  id,
  cursor,
  hasContentEmbedAccess,
  hasGlobalContentEditorAccess,
  height,
  isGlobal,
  isUneditable,
  left,
  onClick,
  onMouseDown,
  onMouseUp,
  opacity,
  pointerEvents,
  isFixedPosition,
  top,
  width,
  isAdvancedModuleWithoutAccess,
  isPaymentsModuleWithoutAccess,
  hasPersonalizationTokenWithoutAccess,
  defaultType,
  isEmbed,
  isStaticSectionModule,
  domNodeRef
}) => {
  var _EditorConfigSingleto;
  const isTrellisTheme = useSelector(getIsTrellisTheme);
  const styles = {
    top,
    left,
    width,
    height
  };
  if (opacity != null) {
    styles.opacity = opacity;
  }
  if (cursor != null) {
    styles.cursor = cursor;
  }
  if (isFixedPosition) {
    styles.position = 'fixed';
  }
  if (pointerEvents != null) {
    styles.pointerEvents = pointerEvents;
  }
  const isRichTextModule = defaultType === 'rich_text';
  const isNonLSModuleHoverOverlayBlocked = isGlobal && !hasGlobalContentEditorAccess || isEmbed && !hasContentEmbedAccess;
  const isNonLSModuleHoverOverlayWithoutAccess = isAdvancedModuleWithoutAccess && !isRichTextModule || isPaymentsModuleWithoutAccess;
  const isNonLSModuleHoverOverlayRichTextWithModulesWithoutAccess = isAdvancedModuleWithoutAccess && isRichTextModule || hasPersonalizationTokenWithoutAccess;
  const isNonLSModuleHoverOverlayGlobalGroup = isGlobal && hasGlobalContentEditorAccess;
  const isNonLSModuleHoverOverlayEmbed = isEmbed && hasContentEmbedAccess;
  const hasUpdatedEditorStyles = !isAdvancedModuleWithoutAccess && !isPaymentsModuleWithoutAccess && !hasPersonalizationTokenWithoutAccess;
  const hasCleanLinesWithoutAccessBars = isAdvancedModuleWithoutAccess || isPaymentsModuleWithoutAccess;
  const allowStaticModuleDragToMoveParentSection = ((_EditorConfigSingleto = EditorConfigSingleton.get('inpage')) === null || _EditorConfigSingleto === void 0 ? void 0 : _EditorConfigSingleto.allowStaticModuleDragToMoveParentSection) || false;
  const colors = getLayoutSectionHoverOverlayColors(isTrellisTheme);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(StyledLayoutSectionHoverOverlay, {
      "data-test-id": "layout-section-hover-overlay",
      onClick: onClick,
      onMouseDown: onMouseDown,
      onMouseUp: onMouseUp,
      $isUneditable: Boolean(isUneditable),
      $isNonLSModuleHoverOverlayBlocked: isNonLSModuleHoverOverlayBlocked,
      $isNonLSModuleHoverOverlayWithoutAccess: isNonLSModuleHoverOverlayWithoutAccess,
      $isNonLSModuleHoverOverlayRichTextWithModulesWithoutAccess: isNonLSModuleHoverOverlayRichTextWithModulesWithoutAccess,
      $isNonLSModuleHoverOverlayGlobalGroup: isNonLSModuleHoverOverlayGlobalGroup,
      $isNonLSModuleHoverOverlayEmbed: isNonLSModuleHoverOverlayEmbed,
      $hasUpdatedEditorStyles: hasUpdatedEditorStyles,
      $hasCleanLinesWithoutAccessBars: hasCleanLinesWithoutAccessBars,
      $colors: colors,
      style: styles,
      ref: domNodeRef,
      children: [isGlobal && !hasGlobalContentEditorAccess && /*#__PURE__*/_jsx(GlobalContentNoAccessLabel, {
        height: height,
        width: width
      }), isStaticSectionModule && !allowStaticModuleDragToMoveParentSection &&
      /*#__PURE__*/
      // The key is for an edge case where two undraggable modules are
      // placed next to each other. When dragging from one of these modules
      // to another, we'll want to remount the overlay so that the
      // useWasDragAttempted state and listeners are reset.
      _jsx(ModuleNotDraggableLabel, {
        height: height,
        width: width
      }, id)]
    })
  );
};
export default LayoutSectionHoverOverlay;